import { Toast } from 'buefy/dist/components/toast';

export const actions = {
  toast(_, payload) {
    if (typeof payload !== 'object') {
      payload = {
        message: payload,
      };
    }

    Toast.open({
      position: 'is-bottom',
      ...payload
    });
  }
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/global.js